<template>
	<div
		v-bind:class="['chat-message', { 'from-me': current_user.id == message.from }, { 'not-from-me': current_user.id != message.from } ]"
	>
		<div v-if="!lastmessage_at || (new Date(message.created_at.replace(' ', 'T'))).getDay() != (new Date(lastmessage_at.replace(' ', 'T'))).getDay()" class="msg_timebreaker">
			{{ formatMessageBreaker(message.created_at) }}
		</div>
		<div v-bind:class="['msg_outer']">
			<div v-if="current_user.id != message.from" v-bind:class="['img_cont_msg', { 'invisible': message.from == lastmessage_from }]"></div>
			<div v-bind:class="['msg_wrapper']">
				<chat-message-attachment-component v-for="attachment in message.attachments" :attachment="attachment" :msgcreated="(new Date(message.created_at)).getTime()" />
				<div v-bind:class="['msg_container', { 'send': current_user.id == message.from } ]" v-if="typeof message.content == 'string'">
					<div v-html="message.content"></div>
					<span class="msg_time">{{ formatMessageTime(message.created_at) }}</span>
				</div>
			</div>
		</div>
		<div class="clearer"></div>
	</div>
</template>

<script>
export default {
	props: ["message", "lastmessage_at", "lastmessage_from", "Laravel"],
	data() {
		return {
			current_user: window.Laravel.user,
		};
	},
	mounted: function() {
		if (typeof this.message.content == "string" && !this.message.content.match(/<a/)) {
			this.message.content = this.message.content.replace(/\n/g,"<br>").replace(/(https:\/\/[^\s]+)/g, "<a href='$1'>$1</a>");
		}
	},
	methods: {
		formatMessageBreaker(time) {
			// + ", " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2)+' Uhr'
			var d = new Date(time.replace(' ', 'T')+'Z');
			return ("0" + d.getUTCDate()).slice(-2) + "." + ("0"+(d.getUTCMonth()+1)).slice(-2) + "." + d.getUTCFullYear();
		},
		formatMessageTime(time) {
			var d = new Date(time.replace(' ', 'T')+'Z');
			return ("0" + d.getUTCHours()).slice(-2) + ":" + ("0" + d.getUTCMinutes()).slice(-2);
		}
	}
};
</script>